import Forgot from "../page/forgot/Forgot";

export default function ForgotHOC({ ...props }) {
  return (
    <>
      <Forgot {...props} />
    </>
  );
}
